import { useState } from "react";

const STORED_KEY = "app_api_key";

export function getStoredKey() {
  return sessionStorage.getItem(STORED_KEY) || "";
}

export function clearStoredKey() {
  sessionStorage.removeItem(STORED_KEY);
}

export default function LoginScreen({ onLogin }) {
  const [key, setKey]     = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    const trimmed = key.trim();
    if (!trimmed) return;

    setLoading(true);
    setError("");

    // Validate by hitting the /costs endpoint with the key
    try {
      const apiUrl = process.env.REACT_APP_API_URL || "";
      const res = await fetch(`${apiUrl}/costs`, {
        headers: { "x-api-key": trimmed },
      });
      if (res.status === 403) {
        setError("Invalid API key.");
        setLoading(false);
        return;
      }
      sessionStorage.setItem(STORED_KEY, trimmed);
      onLogin(trimmed);
    } catch {
      setError("Could not reach API. Check connection.");
    }
    setLoading(false);
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: "#0a0a0a",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "'IBM Plex Mono', monospace",
    }}>
      <div style={{
        width: 380,
        border: "1px solid #333",
        padding: "40px 36px",
        background: "#111",
      }}>
        <div style={{ marginBottom: 32 }}>
          <div style={{ color: "#00FF41", fontSize: 11, letterSpacing: 3, marginBottom: 8 }}>
            AWS ARCHITECT PREP
          </div>
          <div style={{ color: "#e0e0e0", fontSize: 20, fontWeight: 700 }}>
            Access Required
          </div>
          <div style={{ color: "#666", fontSize: 12, marginTop: 6 }}>
            Enter your API key to continue
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 20 }}>
            <div style={{ color: "#888", fontSize: 11, letterSpacing: 1, marginBottom: 8 }}>
              API KEY
            </div>
            <input
              type="password"
              value={key}
              onChange={e => setKey(e.target.value)}
              placeholder="••••••••••••••••••••"
              autoFocus
              style={{
                width: "100%",
                background: "#0a0a0a",
                border: "1px solid #333",
                color: "#e0e0e0",
                fontFamily: "'IBM Plex Mono', monospace",
                fontSize: 14,
                padding: "10px 12px",
                outline: "none",
                boxSizing: "border-box",
              }}
              onFocus={e => e.target.style.borderColor = "#00FF41"}
              onBlur={e => e.target.style.borderColor = "#333"}
            />
          </div>

          {error && (
            <div style={{ color: "#FF4444", fontSize: 12, marginBottom: 16 }}>
              ✗ {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !key.trim()}
            style={{
              width: "100%",
              background: loading || !key.trim() ? "#1a1a1a" : "#00FF41",
              color: loading || !key.trim() ? "#444" : "#000",
              border: "none",
              fontFamily: "'IBM Plex Mono', monospace",
              fontWeight: 700,
              fontSize: 13,
              letterSpacing: 1,
              padding: "12px",
              cursor: loading || !key.trim() ? "not-allowed" : "pointer",
              transition: "background 0.2s",
            }}
          >
            {loading ? "VERIFYING..." : "ENTER →"}
          </button>
        </form>
      </div>
    </div>
  );
}
